// Carga diferida del portal externo: el código del portal solo se descarga cuando la ruta es /portal.
import { lazy, Suspense } from 'react';
import { PantallaCarga } from '../components/Estados';

const PortalRaiz = lazy(() => import('./PortalRaiz'));

export function PortalDiferido() {
  return (
    <Suspense fallback={<PantallaCarga texto="Cargando el portal de UPK…" />}>
      <PortalRaiz />
    </Suspense>
  );
}
